import { find } from 'lodash';
import { IReferenceData } from '../interfaces/form/reference-data.model';

export function getReferenceDataById(
  id: number,
  referenceData: IReferenceData[],
): IReferenceData {
  const data: IReferenceData | undefined = find(
    referenceData,
    (d: IReferenceData) => d.id === id,
  );
  return data?.id
    ? {
        id: data?.id,
        description: data?.description,
        sortOrder: data?.sortOrder,
        value: data?.value,
        extDescr: data?.extDescr,
      }
    : undefined;
}

export function getReferenceDataByValue(
  value: string,
  referenceData: IReferenceData[],
): IReferenceData {
  const data: IReferenceData | undefined = find(
    referenceData,
    (d: IReferenceData) => d.value === value,
  );
  return data?.value
    ? {
        id: data?.id,
        description: data?.description,
        sortOrder: data?.sortOrder,
        value: data?.value,
      }
    : undefined;
}
